module.exports = __webpack_public_path__ + "10_mole.775db6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/10_mole.png
// module id = gOCR
// module chunks = 0